<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">Wettkampf-Einladungen</span>
      <div v-if="gameInvitations.length > 0" class="pt-2">
        <v-row
          v-for="invitation in gameInvitations"
          v-bind:key="invitation.game.uid"
          class="align-center"
        >
          <v-col @click.stop="openInvitation(invitation)" cols="auto" class="pr-1">
            <multi-icon
              :icon="getGameTypeIcon(invitation.game.type)"
              :rightBottomIcon="getPlatformIcon(invitation.game.platform)"
              :rightBottomIconColor="'var(--v-secondary-base)'"
            />

            <v-icon right>{{getGameIcon(invitation.game.game)}}</v-icon>
          </v-col>
          <v-col
            @click.stop="openInvitation(invitation)"
            class="pl-0 flex-grow-1"
            style="word-break: break-word;"
          >{{getGameName(invitation.game.game)}}: {{invitation.game.name}}</v-col>
          <v-col cols="auto" class="text-right px-0">
            <v-btn class="primary" icon large @click.stop="openInvitation(invitation)">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
            <v-btn
              class="mx-2 error"
              icon
              large
              @click="declineInvitation(invitation)"
              :disabled="loading"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <v-row v-else>
        <v-col>
          <span class="caption">Keine Einladungen gefunden.</span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import gameMixin from "@/mixins/gameMixin";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import platformMixins from "@/mixins/platformMixins";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import { MUTATION_GAME_INVITATIONS_LOADED } from "@/plugins/store";

export default {
  name: "GameInvitations",
  mixins: [platformMixins, gameTypeMixin, gameMixin],

  components: {},

  data: () => ({
    loading: false
  }),

  computed: {
    gameInvitations: function() {
      return this.$store.state.gameInvitations;
    }
  },

  mounted() {
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {},
    openInvitation(invitation) {
      this.$router.push(
        "/action/" + encodeURIComponent(invitation.actionToken)
      );
    },
    declineInvitation(invitation) {
      this.loading = true;
      this.$api
        .deleteGameInvitation(invitation.game.uid)
        .then(response => {
          var newInvitations = response.data.gameInvitations;
          this.$store.commit(MUTATION_GAME_INVITATIONS_LOADED, newInvitations);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    }
  }
};
</script>
